import React, { useEffect, useState } from "react"
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    Radio,
    Stack,
    TextField,
    Typography,
    Chip,
    Divider,
    Checkbox
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { CatalogoComplemento, CatalogoComplementoEspecifico, CatalogoComplementoSelecionado, CatalogoItemComplemento, CatalogoOpcao, DetalheItem, ItemDestaque } from "../../CatalogoPage";
import { formatNumberToDinheiro } from "../../../../../utils/dinheiro";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import TextFieldComponent from "../../../../../components/TextField/TextFieldComponent";
import CheckboxComponent from "../../../../../components/checkbox/CheckboxComponent";
import { catalogoService } from "../../../../../service/CatalogoService";
import { Empresa } from "../../../../../provider/empresa/EmpresaContext";

interface Props {
    open: boolean;
    onClose: () => void;
    empresa: Empresa;
    item?: ItemDestaque
    onClickEscolha: (item: DetalheItem) => void;
}

const ModalDetalhesItemComponent = (props: Props) => {
    const midiaAtiva = props.item?.midias?.find(m => m.ativo);

    const [item, setItem] = useState<DetalheItem>({
        id: null,
        nome: "",
        qtd: 1,
        subtotal: 0,
        opcao: undefined,
        complementos: [],
        complementosEspecificos: [],
        midias: [],
        observacao: ""
    });

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();        

        if (item.opcao === undefined) {
            alert("É necessário selecionar uma opção.");
            return;
        }

        props.onClickEscolha(item)

        //props.onClickConfirmar();
    };

    const handleChangeObservacao = (value: string) => {
        setItem({ ...item, observacao: value });
    }

    //const [opcaoSelecionada, setOpcaoSelecionada] = useState();
    /* OPCOES */
    const [opcoes, setOpcoes] = useState<CatalogoOpcao[]>([]);
    const getOpcoes = async (idEmpresa: number, idCategoria: number) => {
        try {
            const data = await catalogoService.getOpcoesPublic(idEmpresa, idCategoria);
            setOpcoes(data);
        } catch (e) {
            console.error(e);
        }
    }

    const handleChangeOpcao = (opcao: CatalogoOpcao) => {
        const novaOpcao = {
            ...opcao,
            idEmpresa: props.empresa?.id
        };

        setItem({
            ...item,
            opcao: novaOpcao
        });
    };

    const renderOpcoes = () => {
        return <BoxComponent
            component="div"
            sx={{ display: "flex", flexDirection: "column" }}
        //mt={4}
        >
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
            >
                <Typography
                    fontWeight={700}
                    textTransform="uppercase"
                    fontSize={14}
                >
                    Escolha o tamanho
                </Typography>

                <Chip
                    label="Obrigatório"
                    size="small"
                    sx={{
                        bgcolor: "#222",
                        color: "white",
                        fontSize: 10,
                        fontWeight: 700,
                        textTransform: "uppercase",
                    }}
                />
            </Stack>

            <TypographyComponent
                variant="caption"
                color="text.secondary"
            >
                Escolha 1 opção.
            </TypographyComponent>

            <BoxComponent
                component="div"
                sx={{ display: "flex", flexDirection: "column" }}
            /*
                mt={2}
                border="1px solid #EEE"
                borderRadius={3}
                */
            >
                {opcoes.map((opcao: CatalogoOpcao, index: number) => {
                    return <Stack
                        key={`opcao-${index}`}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        p={2}
                    >
                        <Stack direction="row" alignItems="center">
                            <Radio
                                checked={item.opcao?.id === opcao.id}
                                onChange={() => handleChangeOpcao(opcao)}
                            />
                            <Typography>{opcao.nome}</Typography>
                        </Stack>
                    </Stack>
                })}
            </BoxComponent>
        </BoxComponent>
    }

    /* COMPLEMENTOS */
    //const [complementosSelecionados, setComplementosSelecionados] = useState<CatalogoComplementoSelecionado[]>([]);
    const handleChangeComplemento = (
        complemento: CatalogoItemComplemento | CatalogoComplementoEspecifico,
        checked: boolean
    ) => {
        if (!complemento.id) return;

        const novoComplemento: CatalogoComplementoSelecionado = {
            id: complemento.id,
            nome: complemento.nome,
            vlrUnitario: complemento.vlrUnitario
        };

        setItem(prev => {
            const complementos = prev.complementos ?? [];

            return {
                ...prev,
                complementos: checked
                    ? complementos.some(c => c.id === novoComplemento.id)
                        ? complementos
                        : [...complementos, novoComplemento]
                    : complementos.filter(c => c.id !== novoComplemento.id)
            };
        });
    };

    const handleChangeComplementoEspecifico = (
        complementoEspecifico: CatalogoComplementoEspecifico,
        checked: boolean
    ) => {
        if (!complementoEspecifico.id) return;

        const novoComplemento: CatalogoComplementoSelecionado = {
            id: complementoEspecifico.id,
            nome: complementoEspecifico.nome,
            vlrUnitario: complementoEspecifico.vlrUnitario
        };

        setItem(prev => {
            const complementosEspecificos = prev.complementosEspecificos ?? [];

            return {
                ...prev,
                complementosEspecificos: checked
                    ? complementosEspecificos.some(c => c.id === novoComplemento.id)
                        ? complementosEspecificos
                        : [...complementosEspecificos, novoComplemento]
                    : complementosEspecificos.filter(c => c.id !== novoComplemento.id)
            };
        });
    };

    const renderComplementos = () => {
        return (
            <BoxComponent
                component="div"
                sx={{ display: "flex", flexDirection: "column" }}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                >
                    <Typography
                        fontWeight={700}
                        textTransform="uppercase"
                        fontSize={14}
                    >
                        Escolha um complemento
                    </Typography>

                    <Chip
                        label="Opcional"
                        size="small"
                        sx={{
                            bgcolor: "#222",
                            color: "white",
                            fontSize: 10,
                            fontWeight: 700,
                            textTransform: "uppercase",
                        }}
                    />
                </Stack>

                <TypographyComponent
                    variant="caption"
                    color="text.secondary"
                >
                    Escolha quantos desejar.
                </TypographyComponent>

                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {props.item?.complementos.map((complemento: CatalogoItemComplemento) => {
                        if (!complemento.ativo) return <></>;

                        const isSelecionado = item.complementos?.some(c => c.id === complemento.id) ?? false;

                        return <>
                            <React.Fragment key={complemento.id}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    p={2}
                                >
                                    <Stack direction="row" alignItems="center">
                                        <CheckboxComponent
                                            id={`check-complemento-${complemento.id}`}
                                            checked={isSelecionado}
                                            onChange={(checked) => handleChangeComplemento(complemento, checked)}
                                        />

                                        <TypographyComponent>
                                            {complemento.nome}
                                        </TypographyComponent>
                                    </Stack>

                                    <TypographyComponent color="text.secondary">
                                        {formatNumberToDinheiro(complemento.vlrUnitario)}
                                    </TypographyComponent>
                                </Stack>

                                {/* {index < complemento.length - 1 && <Divider />} */}
                            </React.Fragment>
                        </>
                    })}

                    {props.item?.complementosEspecificos.map((complemento: CatalogoComplementoEspecifico, index: number) => {
                        if (!complemento.ativo) return <></>;

                        const isSelecionado = item.complementosEspecificos?.some(c => c.id === complemento.id) ?? false;

                        return <>
                            <React.Fragment key={complemento.id}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    p={2}
                                >
                                    <Stack direction="row" alignItems="center">
                                        <CheckboxComponent
                                            id={`check-compl-especifico-${complemento.id}`}
                                            checked={isSelecionado}
                                            onChange={(checked) => handleChangeComplementoEspecifico(complemento, checked)}
                                        />

                                        <TypographyComponent>
                                            {complemento.nome}
                                        </TypographyComponent>
                                    </Stack>

                                    <TypographyComponent color="text.secondary">
                                        {formatNumberToDinheiro(complemento.vlrUnitario)}
                                    </TypographyComponent>
                                </Stack>

                                {/* {index < complemento.length - 1 && <Divider />} */}
                            </React.Fragment>
                        </>
                    })}

                    {/* {opcoes.map((opcao, index) => (
                        
                    ))} */}
                </BoxComponent>
            </BoxComponent>
        );
    };

    /* QUANTIDADE */
    const handleChangeQtd = (incremento: number) => {
        setItem(prev => {
            const qtd = Math.max(1, prev.qtd + incremento);

            return {
                ...prev,
                qtd,
                subtotal: (props.item?.precoVenda ?? 0) * qtd
            };
        });
    };

    useEffect(() => {
        if (!props.item) return;

        setItem({
            id: props.item.id,
            nome: props.item.titulo,
            qtd: 1,
            subtotal: (props.item?.precoVenda ?? 0) * 1,
            complementos: [],
            midias: props.item.midias,
            observacao: ""
        });

        if (!props.empresa) return;

        if (props.empresa.id != null) {
            getOpcoes(props.empresa.id, props.item.idCategoria);
        }


    }, [props.item]);

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            fullWidth
            maxWidth="xs"
            PaperProps={{
                component: "form",
                onSubmit: handleSubmit,
                sx: {
                    borderRadius: 5,
                    overflow: "hidden",
                    height: "90vh",
                    zIndex: 6000
                },
            }}
        >
            <Box position="relative">
                {midiaAtiva && (
                    <BoxComponent component="img"
                        sx={{
                            width: 474.66,
                            height: 224,
                            angle: "0 deg",
                            opacity: 1
                        }}
                        src={midiaAtiva.caminho}
                        alt={`image-${props.item?.titulo}`}
                    />
                )}

                <IconButton
                    onClick={props.onClose}
                    sx={{
                        position: "absolute",
                        top: 16,
                        left: 16,
                        bgcolor: "white",
                        "&:hover": {
                            bgcolor: "white",
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent
                sx={{
                    p: 3,
                    pb: 12,
                }}
            >
                <TypographyComponent variant="h5" //fontWeight={700}
                >
                    {props.item?.titulo}
                </TypographyComponent>

                <TypographyComponent
                    sx={{
                        mt: 1,
                        color: "text.secondary",
                    }}
                >
                    a partir de{" "}
                    <Box
                        component="span"
                        sx={{
                            color: "#F44336",
                            fontWeight: 700,
                        }}
                    >
                        {formatNumberToDinheiro(props.item?.precoVenda ?? 0)}
                    </Box>
                </TypographyComponent>

                <TypographyComponent
                    variant="body2"
                    color="text.secondary"
                    mt={1}
                >
                    {props.item?.descricao}
                </TypographyComponent>

                {renderOpcoes()}

                {renderComplementos()}

                <Box mt={4}>
                    <TypographyComponent
                    //fontWeight={700}
                    //textTransform="uppercase"
                    //fontSize={14}
                    //mb={1}
                    >
                        Alguma observação?
                    </TypographyComponent>

                    <TextFieldComponent
                        id="observacoes"
                        multiline
                        rows={4}
                        fullWidth
                        value={item.observacao}
                        onChange={(e) => handleChangeObservacao(e.target.value)}
                        placeholder="Ex: sem cebola, bem passado, maionese extra..."
                    />
                </Box>
            </DialogContent>

            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    bgcolor: "white",
                    borderTop: "1px solid #EAEAEA",
                    p: 2,
                }}
            >
                <Stack direction="row" spacing={2}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        sx={{
                            border: "1px solid #DDD",
                            borderRadius: 99,
                            px: 1,
                            minWidth: 110,
                            justifyContent: "center",
                        }}
                    >
                        <IconButton size="small" onClick={() => handleChangeQtd(-1)}>
                            <RemoveIcon fontSize="small" />
                        </IconButton>

                        <TypographyComponent
                        //fontWeight={600}
                        >
                            {item.qtd}
                        </TypographyComponent>

                        <IconButton size="small" onClick={() => handleChangeQtd(1)}>
                            <AddIcon fontSize="small" />
                        </IconButton>
                    </Stack>

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            borderRadius: 99,
                            textTransform: "none",
                            py: 1.5,
                        }}
                    >
                        Escolher
                    </Button>
                </Stack>
            </Box>
        </Dialog>
    )
}

export default ModalDetalhesItemComponent;